import apiBaseUrl from '../../utils/config.js';

class PointsInventoryAPI {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/inventory`;
  }

  // Retrieve the JWT token from localStorage
  getToken() {
    return localStorage.getItem('jwt');
  }

  // Return auth headers with JWT
  getAuthHeaders(contentType = 'application/json') {
    const token = this.getToken();
    const headers = {
      ...(contentType && { 'Content-Type': contentType }),
      ...(token && { Authorization: `Bearer ${token}` }),
    };
    return headers;
  }

  // Unified request handler
  async #request(endpoint = '', method = 'GET', body = null, contentType = 'application/json') {
    const url = `${this.baseUrl}${endpoint}`;
    const options = {
      method,
      headers: this.getAuthHeaders(contentType),
    };

    if (body) {
      if (contentType === 'application/json') {
        options.body = JSON.stringify(body);
      } else {
        options.body = body; // For FormData (e.g., file uploads)
      }
    }

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Request failed');
      }

      const responseContentType = response.headers.get('Content-Type') || '';
      return responseContentType.includes('application/json')
        ? await response.json()
        : await response.text();

    } catch (error) {
      console.error(`Error in ${method} ${url}:`, error);
      throw error;
    }
  }

  // ✅ Fixed: Get all items from /all instead of base
  async getAll() {
    return this.#request('/all');
  }

  async getById(id) {
    return this.#request(`/${id}`);
  }

  async addItem(item) {
    return this.#request('/add', 'POST', item);
  }

  async updateItem(id, updatedItem) {
    return this.#request(`/update/${id}`, 'PUT', updatedItem);
  }

  async deleteItem(id) {
    return this.#request(`/delete/${id}`, 'DELETE');
  }

  async getPictures(id) {
    return this.#request(`/${id}/pictures`);
  }

  async uploadPicture(id, formData) {
    return this.#request(`/${id}/pictures`, 'POST', formData, null); // No Content-Type so browser sets boundary
  }
}

export default PointsInventoryAPI;
